import React from "react";
import Header from "./components/Header.js";
import Meme from "./components/Meme.js";

export default function App() {
  return (
    <div>
      <Header />
      <Meme />
    </div>
  );
}
